import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/star/logo.png'
import _imports_1 from '@/assets/star/auth1.png'
import _imports_2 from '@/assets/star/auth2.png'
import _imports_3 from '@/assets/star/auth3.png'


const _withScopeId = n => (_pushScopeId("data-v-8730e734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-header__tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "stat-item" }
const _hoisted_4 = { class: "stat-item" }
const _hoisted_5 = { class: "stat-item" }
const _hoisted_6 = { class: "panel-actions" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "action-icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "action-icon-placeholder"
}
const _hoisted_11 = { class: "action-text" }
const _hoisted_12 = { class: "star-content" }
const _hoisted_13 = {
  key: 0,
  class: "star-list"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "create-strategy-btn" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "create-plus" }, "+"),
  /*#__PURE__*/_createTextVNode(" 创建您的策略 ")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "token-dialog" }
const _hoisted_17 = { class: "token-dialog-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "token-dialog-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "token-logo"
  }),
  /*#__PURE__*/_createTextVNode(" 策略口令粘贴 ")
], -1))
const _hoisted_19 = { class: "token-dialog-body" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "dialog-mask"
}
const _hoisted_22 = { class: "service-dialog" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-title" }, "体验前请先签署服务协议", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-features" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "service-feature-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "service-feature-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-name" }, "组合量化"),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-desc" }, "多种选股因子自由组合，一键回测")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "service-feature-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      class: "service-feature-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-name" }, "个股择时"),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-desc" }, "大模型筛选最优策略，轻松上手")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "service-feature-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      class: "service-feature-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-name" }, "策略跟踪"),
    /*#__PURE__*/_createElementVNode("div", { class: "service-feature-desc" }, "及时获悉策略表现和仓位变动")
  ])
], -1))
const _hoisted_25 = { class: "service-actions" }
const _hoisted_26 = {
  key: 0,
  class: "service-qr-wrap"
}
const _hoisted_27 = {
  ref: "serviceQrRef",
  style: {"width":"120px","height":"120px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-qr-label" }, "打开APP，进入交易-九方星投签署服务协议", -1))
const _hoisted_29 = {
  key: 2,
  class: "login-mask"
}
const _hoisted_30 = {
  key: 3,
  class: "global-loading-mask"
}
const _hoisted_31 = { class: "panel-drawer" }
const _hoisted_32 = { class: "panel-drawer-header" }
const _hoisted_33 = { class: "panel-drawer-title" }
const _hoisted_34 = { class: "panel-drawer-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_StrategyCard = _resolveComponent("StrategyCard")!
  const _component_StarTipDialog = _resolveComponent("StarTipDialog")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_ResultPanel = _resolveComponent("ResultPanel")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "star" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-index",
        style: _normalizeStyle({ background: _ctx.colors.bg })
      }, [
        _createVNode(_component_StarTabBar, {
          modelValue: _ctx.activeTopTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTopTab) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "star-header",
          style: _normalizeStyle({ background: _ctx.isLight ? '#f2f5fa' : _ctx.colors.bgPanel, borderBottom: _ctx.isLight ? '1px solid #dbdfe6' : 'none' })
        }, [
          _createElementVNode("span", {
            class: "star-header__title",
            style: _normalizeStyle({ color: _ctx.colors.textPrimary })
          }, "我的策略", 4),
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTabs, (tab) => {
              return (_openBlock(), _createElementBlock("span", {
                key: tab.value,
                class: _normalizeClass(["tab-item", { active: _ctx.activeFilter === tab.value }]),
                onClick: ($event: any) => (_ctx.switchFilter(tab.value))
              }, _toDisplayString(tab.label), 11, _hoisted_2))
            }), 128))
          ])
        ], 4),
        _createElementVNode("div", {
          class: "star-panel",
          style: _normalizeStyle({ background: _ctx.isLight ? _ctx.colors.bg : '#1F1F1FB2' })
        }, [
          _createElementVNode("div", {
            class: "panel-stats",
            style: _normalizeStyle({ background: _ctx.isLight ? '#f0f2f5' : 'rgba(255,255,255,0.05)' })
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                class: "stat-value",
                style: _normalizeStyle({ color: _ctx.colors.textPrimary })
              }, _toDisplayString(_ctx.summary.totalCount ?? '--'), 5),
              _createElementVNode("span", {
                class: "stat-label",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "策略总数", 4)
            ]),
            _createElementVNode("div", {
              class: "stat-divider",
              style: _normalizeStyle({ background: _ctx.colors.statDivider })
            }, null, 4),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "stat-value",
                style: _normalizeStyle({ color: _ctx.colors.textPrimary })
              }, _toDisplayString(_ctx.summary.avgWinRate ?? '--'), 5),
              _createElementVNode("span", {
                class: "stat-label",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "平均胜率", 4)
            ]),
            _createElementVNode("div", {
              class: "stat-divider",
              style: _normalizeStyle({ background: _ctx.colors.statDivider })
            }, null, 4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "stat-value",
                style: _normalizeStyle({ color: _ctx.summary.avgReturn == null ? _ctx.colors.textPrimary : parseFloat(_ctx.summary.avgReturn) >= 0 ? '#e8392a' : '#00b578' })
              }, _toDisplayString(_ctx.summary.avgReturn ?? '--'), 5),
              _createElementVNode("span", {
                class: "stat-label",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "平均收益(模拟)", 4)
            ])
          ], 4),
          _createElementVNode("div", {
            class: "panel-sep",
            style: _normalizeStyle({ background: _ctx.colors.divider })
          }, null, 4),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
              return (_openBlock(), _createElementBlock("div", {
                key: action.key,
                class: _normalizeClass(["action-btn", { 'action-btn--disabled': !_ctx.canCreate && (action.key === 'stock' || action.key === 'group' || action.key === 'token') }]),
                style: _normalizeStyle({ background: _ctx.colors.bgActionBtn }),
                onClick: action.handler,
                onMouseenter: _cache[1] || (_cache[1] = e => (e.currentTarget as HTMLElement).style.background = _ctx.colors.bgActionBtnHover),
                onMouseleave: _cache[2] || (_cache[2] = e => (e.currentTarget as HTMLElement).style.background = _ctx.colors.bgActionBtn)
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (action.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: action.icon,
                        alt: ""
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "action-name",
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                  }, _toDisplayString(action.name), 5),
                  _createElementVNode("span", {
                    class: "action-desc",
                    style: _normalizeStyle({ color: _ctx.colors.textMuted })
                  }, _toDisplayString(action.desc), 5)
                ])
              ], 46, _hoisted_7))
            }), 128))
          ])
        ], 4),
        _createElementVNode("div", _hoisted_12, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["create-strategy-wrap", { 'create-strategy-wrap--disabled': !_ctx.canCreate }]),
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCreate && _ctx.handleCreate(...args)))
                }, _hoisted_15, 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                  return (_openBlock(), _createBlock(_component_StrategyCard, {
                    key: item.id,
                    item: item,
                    canCreate: _ctx.canCreate,
                    onFollow: _ctx.handleFollow,
                    onLive: _ctx.handleLive,
                    onBlocked: _ctx.showBlockTip
                  }, null, 8, ["item", "canCreate", "onFollow", "onLive", "onBlocked"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showTokenDialog)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-mask",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showTokenDialog = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", {
                    class: "close-icon",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showTokenDialog = false))
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tokenInput) = $event)),
                    class: "token-dialog-input",
                    placeholder: "请粘贴口令...",
                    rows: "5",
                    maxlength: "100"
                  }, null, 512), [
                    [_vModelText, _ctx.tokenInput]
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["token-btn-confirm", { 'token-btn-disabled': !_ctx.tokenInput.trim() }]),
                    disabled: !_ctx.tokenInput.trim(),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmToken && _ctx.confirmToken(...args)))
                  }, "兑换口令", 10, _hoisted_20)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_StarTipDialog, {
          tipDialog: _ctx.tipDialog,
          showQrDialog: _ctx.showQrDialog,
          "onUpdate:showQrDialog": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showQrDialog = $event))
        }, null, 8, ["tipDialog", "showQrDialog"]),
        (_ctx.showServiceDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "service-btn-open",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showServiceQr = true))
                  }, "立即开通"),
                  _createElementVNode("div", {
                    class: "service-refresh",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.initAuth && _ctx.initAuth(...args)))
                  }, "已开通，立即刷新")
                ]),
                (_ctx.showServiceQr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, null, 512),
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showLoginMask)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_a_spin, {
                tip: "加载中，请稍候...",
                size: "large"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.activePanel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "panel-overlay",
              onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.activePanel === 'result' ? '回测记录' : '我的消息'), 1),
                  _createElementVNode("span", {
                    class: "panel-drawer-close",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.activePanel === 'result')
                    ? (_openBlock(), _createBlock(_component_ResultPanel, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }))
}